import React, { useState, useEffect, useRef, useContext, useCallback } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { Grid2, Box, Menu, Grow, MenuItem, IconButton } from "@mui/material";
import LayoutWrapper from "./LayoutWrapper";
import { getAllOrders } from "../../api/request/dashboard/dashboard";
import { getCookies } from "../../services/Cookies";
import SymbolCell from "../../components/tablecells/SymbolCell";
import TabPannel from "../../components/tab/TabPannel";
import TradeModal from "../../components/modal/trading/TradingModal";
import { useDispatch, useSelector } from 'react-redux'
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice'
import { ThemeContext } from "../../context/ThemeContext";
import MenuComponent from '../../components/menu/MenuComponent';
import { setSymbol } from '../../store/Slices/symbolSlice';
import ModifyPosition from "../../components/modal/ModifyPosition";
import SearchWithGroupFilter from "../../components/search/SearchDropdown";
import '../../App.scss'
import CheckIcon from "@mui/icons-material/Check"
import WatchlistTable from "../../components/table/WatchlistTable";
import { setGlobalSymbolsData, setGlobalSymbolID, setTradeModalOpen, setModifyPositionOpen, setModifyPositionDetail, setOneClickSymbolDetail, setEditOrderDetail } from '../../store/Slices/globalSymbolSlice'
import { v4 as uuid } from 'uuid'
import WatchlistTrade from "./MultiOrderScreen";
import AcceptReject from "../../components/modal/AcceptReject/AcceptReject";
import PanelDropZone from "../../components/dropzone/PanelDropZone";
import { DragProvider, useDragContext } from "../../context/DragContext";
import { setChartSymbol } from "../../store/Slices/watchList";
import { SlSettings } from "react-icons/sl";
import OneClickTrading from "../../components/modal/OneClickTrading";
import OneClick from "../../components/modal/OneClick";
import toast from "react-hot-toast";

const Dashboard = () => {
  const { darkMode, direction } = useContext(ThemeContext)
  const dispatch = useDispatch()
  const showCreateOrder = useSelector((state) => state.menu);
  const [loading, setLoding] = useState(false);
  const [openModal, setOpenModal] = useState(false); //on double click modal open 
  const { userDetail } = useSelector(state => state.user);
  // const id = getCookies("clientId");
  const id = userDetail?.id
  const { accountId } = useSelector(state => state.accountSummary)
  const [searchQuery, setSearchQuery] = useState("");
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isSymbolPanelVisible, setIsSymbolPanelVisible] = useState(true);
  const [activeRowId, setActiveRowId] = useState(null);
  const [accountHistory, setAccountHistory] = useState([])
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
  const [hiddenSymbols, setHiddenSymbols] = useState(new Set());
  const [visibleColumns, setVisibleColumns] = useState(['name', 'bid', 'ask', 'spread', 'amount']);
  const [menuPositionTH, setMenuPositionTH] = useState(null);
  const [openNewOrder, setOpenNewOrder] = useState([])
  const { symbols } = useSelector(state => state.watchlist)
  const isOneClick = useSelector(state => state.watchlist?.isOneclick)
  const chartLayoutType = useSelector(state => state.watchlist?.chartLayoutType)
  const { endDrag } = useDragContext();

  const { globalSymbol, globalSymbolID, orderPanelOpen, modifyPositionModalOpen, modifyPositionDetail } = useSelector(state => state.globalSymbol)
  const dataRef = useRef(symbols)
  const ref = useRef()

  const handleSearch = (query) => {
    setSearchQuery(query);
    setIsSearchDropdownOpen(query.length > 0);
  };

  useEffect(() => {
    dataRef.current = symbols;
  }, [symbols]) // This will run whenever selectedSymbol changes

  const lastSelectedSymbolId = useRef(null);
  const handleRowClick = (symbol) => {
    lastSelectedSymbolId.current = symbol.id;
    dispatch(setGlobalSymbolsData(symbol));
    dispatch(setGlobalSymbolID(symbol?.id));
    dispatch(setSymbol({ symbolId: symbol?.id, symbolName: symbol.name, bid: symbol.bid, ask: symbol.ask }));
  };

  const handleRowDoubleClick = (symbol) => {
    dispatch(setTradeModalOpen(true));
    dispatch(setModifyPositionOpen(false));
    dispatch(setSymbol({ symbolId: symbol?.id, symbolName: symbol.name }));
    dispatch(setEditOrderDetail(null))
    dispatch(setChartSymbol([0, symbol?.id]))
    const panel = ref.current;
    if (panel) {
      panel.resize(30);
    }
  };

  const closeModal = () => {
    setOpenModal(false);
    dispatch(setTradeModalOpen(false));
    const panel = ref.current;
    if (panel) {
      panel.resize(0);
    }
  };
  const handleResize = (newSize, oldSize) => {
    // if (newSize < 10) {
    //   closeModal();
    // }
  };
  const isTradePanelOpen = showCreateOrder;
  const handleCloseCreateOrderPanel = () => {
    dispatch(handleCloseCreateOrder());
    closeModal();
  };

  const handleRowRightClick = useCallback((event, row) => {
    event.preventDefault();
    setMenuPosition({ top: event.clientY, left: event.clientX });
    // dispatch(setGlobalSymbolID(row.id))
    dispatch(setSymbol({ symbolId: row?.id, symbolName: row.name, bid: row.bid, ask: row.ask }));
    setSelectedRow(row);
  }, [dispatch])

  const handleCloseMenu = () => {
    setMenuPosition(null);
  };

  const handleOpenOneTradeModal = () => {
    dispatch(setTradeModalOpen(true))
    dispatch(setEditOrderDetail(null))
    dispatch(setModifyPositionOpen(false))
    if (selectedRow) {
      dispatch(setGlobalSymbolID(selectedRow?.id))
    }
    const panel = ref.current;
    if (panel) {
      panel.resize(30);
    }
    handleCloseMenu();
  };

  useEffect(() => {
    console.log("orderPanel", orderPanelOpen)
    if (orderPanelOpen) {
      dispatch(setModifyPositionOpen(false))
    }
  }, [orderPanelOpen]);


  const handleChartClick = () => {
    if (selectedRow) {
      dispatch(setGlobalSymbolsData(selectedRow))
      dispatch(setGlobalSymbolID(selectedRow?.id))
      dispatch(setChartSymbol([0, selectedRow?.id]))
    }
  };

  const openOneClickModal = () => {
    dispatch(setOneClickSymbolDetail(globalSymbol))
    if (chartLayoutType !==  0) {
      toast.error("One-click trading only works in single chart mode");
      return;
    }
    setModalOpen(true);
  };

  const closeOneClickModal = () => {
    setModalOpen(false);
  }

  const toggleSymbolPanel = () => {
    setIsSymbolPanelVisible((prev) => !prev);
  };
  const currentSymbol = useSelector((state) => state.symbol.selectedSymbol.symbolId);
  const currentSymbolIdForModal = currentSymbol || globalSymbolID; // Determine symbolId priority

  const handleOpenModifyPositionModal = (orderDetails) => {
    dispatch(setModifyPositionOpen(true))
    dispatch(setModifyPositionDetail(orderDetails))

    const panel = ref.current;
    if (panel) {
      panel.resize(30); // Resize the panel to 30% width
    }
  };
  const handleCloseModifyPositionModal = () => {
    dispatch(setModifyPositionOpen(false))
    const panel = ref.current;
    if (panel) {
      panel.resize(0); // Close the panel
    }
  };

  const fetchOrders = async () => {
    try {
      const updatedOrders = await getAllOrders(accountId);
      setAccountHistory(updatedOrders?.data);
    } catch (error) {
      console.error("Error fetching updated orders:", error);
    }
  };

  useEffect(() => {
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    setHiddenSymbols(new Set(storedHiddenSymbols));

    const storedColumns = JSON.parse(localStorage.getItem(`visibleColumns_${id}`));
    if (storedColumns) {
      setVisibleColumns(storedColumns);
    }
  }, [id]); // Depend on `id` to load the correct user's data

  const symbolIds = Object.keys(symbols).map(Number);
  const handleHideAllSymbols = () => {
    const allHidden = new Set(symbolIds);
    setHiddenSymbols(allHidden);
    localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify(Array.from(allHidden)));
  };

  const handleShowAllSymbols = () => {
    setHiddenSymbols(new Set());
    localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify([]));
  };
  const handleColumnVisibilityToggle = (columnDataIndex) => {
    setVisibleColumns((prev) => {
      const updatedColumns = prev.includes(columnDataIndex)
        ? prev?.filter(col => col !== columnDataIndex)
        : [...prev, columnDataIndex];

      localStorage.setItem(`visibleColumns_${id}`, JSON.stringify(updatedColumns));
      return updatedColumns;
    });
  };

  const handleTableHeaderRightClick = (event) => {
    event.preventDefault();
    const menuPosition = { top: event.clientY, left: event.clientX };
    setMenuPositionTH(menuPosition);
  };
  const symbolCellData = SymbolCell();
  const visibleColumnsData = symbolCellData.filter(col => visibleColumns.includes(col.dataIndex));

  const data = Object.values(symbols).filter(symbol => symbol.isVisible && symbol.isUsed);
  useEffect(() => {
    if (data && data.length > 0) {
      const visibleSymbols = data.filter(symbol => !hiddenSymbols.has(symbol?.id));

      if (visibleSymbols.length > 0) {
        const firstSymbol = visibleSymbols[0];
        if (firstSymbol?.id && firstSymbol?.name) {
          dispatch(setGlobalSymbolsData(firstSymbol));
        }
      }
    }
  }, [symbols, hiddenSymbols]);


  const handleChartFromTradeTabClick = (symbol) => {
    dispatch(setGlobalSymbolsData(symbol))
  };
  const handleOpenNewDashboard = (symbolName, symbolId) => {
    dispatch(setSymbol({ symbolId, symbolName }));
    // setOpenNewOrder(prev => [...prev, symbolId]);
    setOpenNewOrder(prev => [...prev, { Uid: uuid(), symbolId }]);
    handleCloseMenu();
  };

  const getAgreementStatus = () => {
    const clientId = getCookies("clientId"); // Assuming you have a method to get the clientId
    const agreementKey = `oneClickTradingAgreement_${clientId}`;
    const agreementStatus = JSON.parse(localStorage.getItem(agreementKey));
    return agreementStatus?.agreed || false; // Returns true if agreed, false otherwise
  };
  const agreementStatus = getAgreementStatus()

  const onAcceptOneClickTrading = () => {
    setModalOpen(true);
    closeOneClickModal();
  };
  useEffect(() => {
    if (agreementStatus) {
      setModalOpen(true);
    }
  }, [agreementStatus]);
  const disabledCols = ['name', 'bid', 'ask', "amount"];
  const shouldDisableAmount = modalOpen && agreementStatus;
  // const disabledColumns = shouldDisableAmount ? [...disabledCols, 'amount'] : disabledCols;
  const disabledColumns = shouldDisableAmount ? [...disabledCols] : disabledCols;
  const handleFocus = () => {
    setIsSearchDropdownOpen(true);
  };
  const handleClose = () => {
    setSearchQuery("");
    setIsSearchDropdownOpen(false);
  };
  const handleCloseHeaderMenu = () => {
    setMenuPositionTH(null);
  };

  const renderChartLayout = () => {
    const panelStyle = { backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', transition: "background-color 0.2s ease" };

    switch (chartLayoutType) {
      case 0: // Full width layout
        return (
          <PanelDropZone id="0" >
            {/* <TradingViewChart sx={{ position: 'relative' }} /> */}
          </PanelDropZone>
        );

      case 1: // Two columns layout
        return (
          <PanelGroup direction="horizontal">
            <Panel defaultSize={50}>
              <PanelDropZone id="0" ></PanelDropZone>
            </Panel>
            <PanelResizeHandle style={{ ...panelStyle, width: "3px" }} />
            <Panel defaultSize={50}>
              <PanelDropZone id="1" ></PanelDropZone>
            </Panel>
          </PanelGroup>
        );

      case 2: // Two rows layout
        return (
          <PanelGroup direction="vertical">
            <Panel defaultSize={50}>
              <PanelDropZone id="0" ></PanelDropZone>
            </Panel>
            <PanelResizeHandle style={{ ...panelStyle, height: "3px" }} />
            <Panel defaultSize={50}>
              <PanelDropZone id="1" ></PanelDropZone>
            </Panel>
          </PanelGroup>
        );

      case 3: // Grid layout (1x2)
        return (
          <PanelGroup direction="horizontal">
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={100}>
                  <PanelDropZone id="0" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
            <PanelResizeHandle style={{ ...panelStyle, width: "3px" }} />
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={50}>
                  <PanelDropZone id="1" ></PanelDropZone>
                </Panel>
                <PanelResizeHandle style={{ ...panelStyle, height: "3px" }} />
                <Panel defaultSize={50}>
                  <PanelDropZone id="2" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
          </PanelGroup>
        );

      case 4: // Grid layout (2x2)
        return (
          <PanelGroup direction="horizontal">
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={50}>
                  <PanelDropZone id="0" ></PanelDropZone>
                </Panel>
                <PanelResizeHandle style={{ ...panelStyle, height: "3px" }} />
                <Panel defaultSize={50}>
                  <PanelDropZone id="1" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
            <PanelResizeHandle style={{ ...panelStyle, width: "3px" }} />
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={100}>
                  <PanelDropZone id="2" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
          </PanelGroup>
        );

      case 5: // Grid layout (2x2)
        return (
          <PanelGroup direction="horizontal">
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={50}>
                  <PanelDropZone id="0" ></PanelDropZone>
                </Panel>
                <PanelResizeHandle style={{ ...panelStyle, height: "3px" }} />
                <Panel defaultSize={50}>
                  <PanelDropZone id="2" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
            <PanelResizeHandle style={{ ...panelStyle, width: "3px" }} />
            <Panel defaultSize={50}>
              <PanelGroup direction="vertical">
                <Panel defaultSize={50}>
                  <PanelDropZone id="1" ></PanelDropZone>
                </Panel>
                <PanelResizeHandle style={{ ...panelStyle, height: "3px" }} />
                <Panel defaultSize={50}>
                  <PanelDropZone id="3" ></PanelDropZone>
                </Panel>
              </PanelGroup>
            </Panel>
          </PanelGroup>
        );
      default:
        return (
          <PanelDropZone id="0"></PanelDropZone>
        ); // Default to full width
    }
  };
  return (
    <>
      <DragProvider>
        <div onDrop={e => { e.preventDefault(); endDrag() }}>
          <LayoutWrapper openOneClickModal={openOneClickModal} closeOneClickModal={closeOneClickModal} isSymbolPanelVisible={isSymbolPanelVisible} toggleSymbolPanel={toggleSymbolPanel} handleOpenOneTradeModal={handleOpenOneTradeModal} currentSymbolId={currentSymbolIdForModal} handleOpenNewDashboard={handleOpenNewDashboard}>
            <Grid2 style={{ height: 'calc(100vh - 44px)' }}>
              <PanelGroup key={direction} direction="vertical" style={{ height: "100%", }}>
                <Panel id="top-panel" order={1} minSize={35} >
                  <PanelGroup direction="horizontal">
                    <Panel key={`${modifyPositionModalOpen}-${orderPanelOpen}`} id="trade-panel" order={2} minSize={0} defaultSize={orderPanelOpen ? 20 : modifyPositionModalOpen ? 20 : 0} maxSize={orderPanelOpen ? 20 : modifyPositionModalOpen ? 20 : 0} size={20} style={{ transition: "width 0.5s ease", }} onResize={handleResize} ref={ref}>
                      <Box style={{ height: "100%", width: "100%" }}>
                        {modifyPositionModalOpen && <ModifyPosition onClose={handleCloseModifyPositionModal} onOrderModified={fetchOrders} />}
                        {(orderPanelOpen || openModal) && (<TradeModal open={isTradePanelOpen} onClose={handleCloseCreateOrderPanel} showCloseButton={true} isEditMode={false} />)}
                      </Box>
                    </Panel>
                    <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', width: "3px", transition: "background-color 0.2s ease", }} />
                    <Panel key={`chart-layout-${chartLayoutType}`} id="chart-panel" style={{ position: "relative" }} order={3} defaultSize={isSymbolPanelVisible ? (isTradePanelOpen ? 50 : 70) : 100}>
                      {chartLayoutType === 0 && modalOpen && agreementStatus && <OneClick open={modalOpen} onClose={closeOneClickModal} />}
                      {renderChartLayout()}
                    </Panel>
                    {modalOpen && !agreementStatus && <OneClickTrading isOpen={openOneClickModal} onAccept={onAcceptOneClickTrading} onClose={closeOneClickModal} />}
                    <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', width: "3px", transition: "background-color 0.2s ease", }} />
                    {isSymbolPanelVisible && (<Panel id="symbol-panel" order={4} maxSize={50} minSize={25} defaultSize={isTradePanelOpen ? 25 : 30}>
                      <Box sx={{ height: "100%", width: "100%", padding: 0, margin: 0 }}>
                        <Box sx={{ height: "100%" }}>
                          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" p={1} pb={1}>
                            <Box sx={{ flex: 1 }}>
                              <SearchWithGroupFilter onClose={handleClose} onFocus={handleFocus} onSearchChange={handleSearch} setIsSearchDropdownOpen={(isOpen) => { setIsSearchDropdownOpen(isOpen); }} />
                            </Box>

                            {!isSearchDropdownOpen && (
                              <IconButton onClick={(e) => setMenuPositionTH({ top: e.clientY, left: e.clientX })} size="small" sx={{ ml: 1 }}>
                                <SlSettings style={{ fontSize: 18, color: darkMode ? '#fff' : '#000' }} />
                              </IconButton>
                            )}
                          </Box>

                          <WatchlistTable columns={visibleColumnsData} handleRowClick={handleRowClick} onRowDoubleClick={handleRowDoubleClick} activeRowId={activeRowId} onRowRightClick={handleRowRightClick} loading={loading} onHeaderClick={handleTableHeaderRightClick} handleShowAllSymbols={handleShowAllSymbols}></WatchlistTable>


                          <Menu open={Boolean(menuPositionTH)} onClose={handleCloseHeaderMenu} anchorReference="anchorPosition" anchorPosition={menuPositionTH} sx={{ '& .MuiList-root': { padding: 0 } }} TransitionComponent={Grow}>
                            <div style={{ backgroundColor: darkMode ? "#262f3f" : "" }}>
                              {symbolCellData
                                .filter((col) => !disabledColumns.includes(col.dataIndex))
                                .map((col) => (
                                  <MenuItem key={col.dataIndex} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", color: darkMode ? "white" : "black", }} onClick={() => handleColumnVisibilityToggle(col.dataIndex)}>
                                    {col.title}{visibleColumns.includes(col.dataIndex) && (<CheckIcon sx={{ fontSize: 18, color: "#4597ff" }} />)}
                                  </MenuItem>
                                ))}
                            </div>

                          </Menu>

                          <Menu open={Boolean(menuPosition)} onClose={() => { setMenuPosition(null) }} anchorReference="anchorPosition" anchorPosition={menuPosition} sx={{ "& .MuiList-root": { padding: 0 }, }} TransitionComponent={Grow}>
                            <MenuComponent closeMenu={handleCloseMenu} onChartClick={handleChartClick} darkMode={darkMode} onOpenTradeModal={handleOpenOneTradeModal} handleOpenNewDashboard={() => handleOpenNewDashboard(selectedRow.name, selectedRow?.id)} isTradePanelOpen={isTradePanelOpen} selectedRow={selectedRow} onHideAllSymbols={handleHideAllSymbols} onShowAllSymbols={handleShowAllSymbols} />
                          </Menu>
                          {/* handleOpenNewDashboard={handleOpenNewDashboard} */}
                        </Box>
                      </Box>
                    </Panel>
                    )}
                  </PanelGroup>
                </Panel>
                <PanelResizeHandle style={{ backgroundColor: darkMode ? "var(--borderDark)" : 'var(--borderLight)', height: "3px" }} />
                <Panel id="bottom-panel" order={5} minSize={25} maxSize={50} defaultSize={30}>
                  <div style={{ height: "100%", width: "100%" }}><TabPannel handleOpenOneTradeModal={handleOpenOneTradeModal} handleOpenModifyPositionModal={handleOpenModifyPositionModal} handleChartFromTradeTabClick={handleChartFromTradeTabClick} /></div>
                </Panel>
              </PanelGroup>
            </Grid2>
          </LayoutWrapper>
          <AcceptReject />
          {<WatchlistTrade openNewOrder={openNewOrder} setOpenNewOrder={setOpenNewOrder} />}
        </div >
      </DragProvider>
    </>
  );
};

export default Dashboard;


// Function to render chart panels based on layout type

